import React, { useState } from 'react'
import Grid from '@mui/material/Unstable_Grid2'
import Box from '@mui/material/Box'

export default function OptionsQuestion(props) {

    function updateAnswer(answer) {
        props.updateAnswer(answer)
        if (!props.multiselect) {
            props.nextStage(answer)
        }
    }

    function getClassName(value, img) {
        let className = 'calc-option';
    
        // Handle both single and multiple answers
        const isSelected = props.multiselect
            ? props.answer.includes(value)
            : props.answer === value;
    
        if (isSelected) {
            className += ' active';
        }
    
        if (!img) {
            className += ' text-only';
        }
    
        return className;
    }
    

    return (
        <Grid container alignItems='center' justifyContent='center' spacing={1} sx={{ textAlign: 'center' }}>
            <Grid xs={12}>
                <h2>{props.question}</h2>
                {props.subtext ? (
                    <p className='question-subtext'>{props.subtext}</p>
                ) : (
                    <p className='question-subtext hide'>Hide</p>
                )}
            </Grid>
            {props.options.map((option, i) => {
                return (
                    <Grid xs={12} sm={6} key={i}>
                        <Box className={getClassName(option.value, option.img)} elevation={2} onClick={() => updateAnswer(option.value)}>
                            {option.img &&
                                <img src={option.img} className='calc-image' />
                            }
                            <p>{option.value}</p>
                            {option.subtext &&
                                <p className='option-subtext'>{option.subtext}</p>
                            }
                        </Box>
                    </Grid>
                )
            })}
        </Grid>
    )
}